import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { CvTemplateConverterPort } from 'application/template/cv/port/cv-template-converter.port';
import { CvTemplateOutput } from 'document/model/cv-template.output';
import { CvTemplate } from 'domain/template/cv/cv-template';
import { CvTemplateI18n } from 'domain/template/cv/cv-template-i18n';

@Injectable()
export class CvTemplateConverterAdapter implements CvTemplateConverterPort {
	public cvTemplateAsEntity(output: CvTemplateOutput): CvTemplate {
		if (!output) {
			return null;
		}

		return new CvTemplate(
			output.id,
			output.organizationId,
			output.updateTimestamp,
			output.creationTimestamp,
			output.localizations.map((loc) => new CvTemplateI18n(loc.name, loc.locale))
		);
	}

	public cvTemplatesAsEntities(outputs: CvTemplateOutput[]): CvTemplate[] {
		return reject(outputs, isNil).map((output) =>
			this.cvTemplateAsEntity(output)
		);
	}
}
